/**
 * 数据埋点对应事件 key 集合
 */
import otherKeys from './other';
import chatKeys from './chat';
import contactKeys from './contact';
import channelKeys from './channel';
import marketing from './marketing';

export default {
    ...otherKeys,
    ...chatKeys,
    ...contactKeys,
    ...channelKeys,
    ...marketing,
};
